module.exports = __webpack_public_path__ + "img/obiettivi_iniziative.613b39eb.svg";